// ─── Groups & Teams Design Tokens ─────────────────────────

export const GT_COLORS = {
    // Primary
    primary: '#206FA5',
    primaryLight: '#EBF2FA',
    primaryHover: '#2B5A87',

    // Status
    green: '#16A34A',
    greenLight: '#DCFCE7',
    greenBorder: '#BBF7D0',
    greenBg: '#F0FDF4',
    amber: '#D97706',
    amberLight: '#FEF3C7',
    amberBorder: '#FDE68A',
    amberBg: '#FFFBEB',
    amberDark: '#92400E',
    red: '#DC2626',
    redLight: '#FEE2E2',
    redBorder: '#FCA5A5',
    redBg: '#FEF2F2',

    // Text
    textPrimary: '#1a1a2e',
    textSecondary: '#4A5568',
    textMuted: '#6B7A90',
    textFaint: '#9AA4B5',
    textDisabled: '#CBD5E1',

    // Backgrounds & Borders
    cardBg: '#ffffff',
    pageBg: '#F5F7FA',
    headerBg: '#FAFBFC',
    hoverBg: '#F8FAFC',
    border: '#E2E7ED',
    borderLight: '#F0F2F5',
    borderInput: '#DDE2E8',

    // Badges
    badgeTagBg: '#E8F4FD',
    badgeTagColor: '#206FA5',
    badgeGrayBg: '#F1F5F9',
    badgeGrayColor: '#64748B',

    // Override badges
    overrideOrgBg: '#F1F5F9',
    overrideOrgColor: '#64748B',
    overrideCustomBg: '#DBEAFE',
    overrideCustomColor: '#1E40AF',

    // Calendar
    calDayBg: '#DCFCE7',
    calDayBorder: '#16A34A',
    calDayText: '#166534',
    calNightBg: '#DBEAFE',
    calNightBorder: '#206FA5',
    calNightText: '#1E40AF',
} as const;
